import { render, staticRenderFns } from "./ForgetForm.vue?vue&type=template&id=5d218df2&scoped=true&"
import script from "./ForgetForm.vue?vue&type=script&lang=js&"
export * from "./ForgetForm.vue?vue&type=script&lang=js&"
import style0 from "./ForgetForm.vue?vue&type=style&index=0&id=5d218df2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d218df2",
  null
  
)

export default component.exports